/* eslint-disable camelcase */

export default function spAddToCart({ childReportingCategory: item_child_reporting_category, parentReportingCategory: item_parent_reporting_category, brand: item_brand, name: item_name, isPrivateLabel, isAutoShip, isSmartPak, itemNumber: item_id, id: item_variant, quantity, price }) {
    const convertToYesNo = value => typeof value !== 'boolean' ? value : value ? 'yes' : 'no';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_add_to_cart',
        ecommerce: {
            items: [
                {
                    item_name,
                    item_id,
                    item_variant,
                    item_brand,
                    item_parent_reporting_category,
                    item_child_reporting_category,
                    item_private_label: convertToYesNo(isPrivateLabel),
                    item_autoship: convertToYesNo(isAutoShip),
                    item_smartpak: convertToYesNo(isSmartPak),
                    currency: 'USD',
                    price,
                    quantity
                }
            ]
        }
    });
} 